import { createPinia } from 'pinia'

if (!window.pinia) {
    window.pinia = createPinia()
}

export default window.pinia
